import querystring from 'vux/src/tools/querystring/index.js'

import moment from 'dayjs';

/**
* 是否微信浏览器
* @returns {boolean}
*/
export function isWechat() {
const ua = window.navigator.userAgent.toLowerCase();
if (ua.match(/MicroMessenger/i) == 'micromessenger') {
return true;
} else {
return false;
}
}

/**
* 是否是IOS
* @returns {boolean}
*/
export function isIOS() {
return navigator.userAgent.toLowerCase().match(/iphone|ipad/i);
};

/**
* 休眠， 用于调试
*
* @export
* @param {any} time
* @returns
*/
export async function sleep(time) {
return await new Promise((resolve) => {
setTimeout(() => resolve(true), time);
});
}

/**
* 正整数的库存
* @param val
* @returns {*}
*/
export function validateStock(val) {
const regStrs = [
['^0(\\d+)$', '$1'], //禁止录入整数部分两位以上，但首位为0
['[^\\d]+', ''] 
];
for (let i = 0; i < regStrs.length; i++) {
const reg = new RegExp(regStrs[i][0]);
val = val.replace(reg, regStrs[i][1]);
}

return val ? parseInt(val) : 0;
}

/**
* 获取route对应的url
*/
export function getRouteUrl(path, query) {
return path + '?' + querystring.stringify(query);
}

/**
* 解析URL
* @param url
* @returns {{source: *, protocol, host, port, query, params, file: string, hash, path, relative: string, segments}}
*/
export function parseURL(url) {
var a = document.createElement('a');
a.href = url;
return {
source: url,
protocol: a.protocol.replace(':', ''),
host: a.hostname,
port: a.port,
query: a.search,
params: (function () {
var ret = {},
seg = a.search.replace(/^\?/, '').split('&'),
len = seg.length, i = 0, s;
for (; i < len; i++) {
if (!seg[i]) {
continue;
}
s = seg[i].split('=');
ret[s[0]] = s[1];
}
return ret;
})(),
file: (a.pathname.match(/\/([^\/?#]+)$/i) || [, ''])[1],
hash: a.hash.replace('#', ''),
path: a.pathname.replace(/^([^\/])/, '/$1'),
relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [, ''])[1],
segments: a.pathname.replace(/^\//, '').split('/')
};
}

/**
* 获取活动状态
* @param dateInfo
* @returns {*}
*/
export function getStatus(nowTime, startTime, endTime) {




nowTime = moment(new Date());
startTime = moment(startTime);
endTime = moment(endTime);




let status;
if (nowTime.isBefore(startTime) && nowTime.isBefore(endTime)) {
status = 'WILL';
} else if ((nowTime.isSame(startTime) || nowTime.isAfter(startTime)) && nowTime.isBefore(endTime)) {
status = 'ING';
} else if (nowTime.isAfter(startTime) && nowTime.isAfter(endTime)) {
status = 'DONE';
}

return status;
}

export function getTimeOffset(endTime, nowTime) {
let totalSecs = endTime.getTime() - nowTime.getTime();
totalSecs = Math.ceil(totalSecs / 1000);
totalSecs = totalSecs < 0 ? 0 : totalSecs;

const padTimeStr = (num) => {
if (num < 10) {
num = '0' + num;
}
return num;
};

const fmt = {
seconds: padTimeStr(totalSecs % 60),
minutes: padTimeStr(Math.floor(totalSecs / 60) % 60),
hours: padTimeStr(Math.floor(totalSecs / 60 / 60))
};



return fmt;
}





































// WEBPACK FOOTER //
// ./src/utils/F.js